import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_EXPORT_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import ExportRecipeByStoreModal from '../components/ExportRecipeByStoreModal';

const MODAL_WIDTH = '600px';
const MODAL_CONTENT_PADDING = '24px';

export const getExportByStoreModalConfig = ({
  groups,
  selectedGroups,
  setSelectedGroups,
  stores,
  selectedStores,
  setSelectedStores,
  handleExport,
  handleCloseCleanUp,
}) => ({
  type: 'action',
  width: MODAL_WIDTH,
  height: 'auto',
  icon: '/images/inpulse/file-download-black-small.svg',
  title: i18next.t('ADMIN.RECIPES.EXPORT_BY_STORE_MODAL_TITLE'),
  customPadding: MODAL_CONTENT_PADDING,
  applyOverflow: false,
  isLoading: false,
  handleCloseCleanUp,
  component: ExportRecipeByStoreModal,
  data: {
    groups,
    selectedGroups,
    setSelectedGroups,
    stores,
    selectedStores,
    setSelectedStores,
  },
  actions: [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_EXPORT_BUTTON(),
      isDisabled: !selectedStores.length,
      handleClick: handleExport,
    },
  ],
});
